import React from "react";
import "./nextDayMatches.css";
import Moment from "moment";
import teamImage from "../../../utilities/constants.json";

const imageUrl = teamImage.team_image;

const NextDayMatches = (prop) => {
  if (!(!!prop?.match?.fix_team_a &&!!prop?.match?.fix_team_b))return;
  return (
    <div className="nextDayMatches">
      <div className="nextDayMatches-wrapper">
        <div className="nextDayMatches-topSection">
          <h6>M{prop.match.fix_number}</h6>
          <h6>
            {Moment.utc(prop.match.fix_time_qatar_string, "YYYY-MM-DD HH:mm:ss").format(
              "MMM DD, hh:mm a"
            )}
          </h6>
        </div>

        <div className="nextDayMatches-bottomSection">
          <div className="row align-items-center">
            {/* TEAM A */}
            <div className="col-5">
              <div className="nextDayMatches-team1-wrapper">
                <div className="team1-flag">
                  <img src={imageUrl + prop?.match?.fix_team_a?.team_flag} alt="" />
                </div>
                <p className="team1">{prop?.match?.fix_team_a?.team_name}</p>
              </div>
            </div>

            <div className="col-2">
              <div className="nextDayMatches-seperator-wrapper">
                <div className="nextDayMatches-seperator"></div>
              </div>
            </div>

            {/* TEAM B */}
            <div className="col-5">
              <div className="nextDayMatches-team2-wrapper">
                <p className="team2">{prop?.match?.fix_team_b?.team_name}</p>
                <div className="team2-flag">
                  <img src={imageUrl + prop?.match?.fix_team_b?.team_flag} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NextDayMatches;
